import { FormattedMessage } from 'react-intl'

import { Marking, Mark } from 'components/Mark'

import {
  ConnectedAppContainer,
  ConnectedAppIconContainer,
  ConnectedAppIconImg,
  ConnectedAppStatusText,
} from './styles'
import { connectedAppsMessages } from '../../../messages'
import { PartnerShape } from '../../../types'

interface ConnectedAppProps {
  connectedApp: PartnerShape
}

function ConnectedApp(props: ConnectedAppProps) {
  const { active, iconUrl } = props.connectedApp

  return (
    <ConnectedAppContainer>
      <ConnectedAppIconContainer>
        <ConnectedAppIconImg
          src={iconUrl}
          alt="Savant connected application icon"
        />
      </ConnectedAppIconContainer>
      <ConnectedAppStatusText>
        {active ? (
          <>
            <FormattedMessage {...connectedAppsMessages.active} />
            <Mark marking={Marking.Check} />
          </>
        ) : (
          <FormattedMessage {...connectedAppsMessages.inactive} />
        )}
      </ConnectedAppStatusText>
    </ConnectedAppContainer>
  )
}

export default ConnectedApp
